<template>
  <el-drawer
    :visible.sync="localVisible"
    :with-header="false"
    :append-to-body="appendToBody"
    :close-on-click-modal="false"
    :destroy-on-close="destroyOnClose"
    :direction="direction"
    :size="width"
    @close="handleClose"
  >
    <div class="drawer-wrapper flex flex-col h-full">
      <div class="drawer-header flex items-center justify-between h-68 pl-24 pr-20 bg-white flex-shrink-0">
        <div class="drawer-title text-18 lh-18">{{ title }}</div>
        <i class="el-icon-close drawer-close cursor-pointer text-22" @click="userClose"></i>
      </div>
      <div class="drawer-content flex-1 overflow-y-auto p-20" v-if="!isTabDrawer">
        <div class="bg-white px-32 py-28 border-radius-4 drawer-content-box" v-if="isDataSelect">
          <slot />
        </div>
        <div v-else>
          <slot/>
        </div>
      </div>
      <div class="drawer-tab-content flex-1 h-full overflow-hidden flex flex-col" v-if="isTabDrawer">
        <slot name="tab-content" />
      </div>

      <div class="drawer-footer bg-white h-68 px-20 flex gap-8 flex-end items-center flex-shrink-0" v-if="showFooter">
        <slot name="footer">
          <el-button size="medium" @click="userClose" v-if="showCancelButton">{{ cancelText }}</el-button>
          <el-button size="medium" @click="$emit('save')" :loading="saveLoading" v-if="showSaveButton && saveText">{{ saveText }}</el-button>
          <el-button v-if="showConfirmButton" type="primary" size="medium" class="bg-primary-light" :loading="confirmLoading" @click="$emit('confirm')">{{ confirmText }}</el-button>
        </slot>
      </div>
    </div>
  </el-drawer>
  
</template>

<script>
export default {
  name: 'PageDrawer',
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '详情' },
    width: { type: [String, Number], default: '640px' },
    appendToBody: { type: Boolean, default: true },
    modal: { type: Boolean, default: true },
    closeOnClickModal: { type: Boolean, default: false },
    destroyOnClose: { type: Boolean, default: false },
    direction: { type: String, default: 'rtl' },
    showFooter: { type: Boolean, default: true },
    cancelText: { type: String, default: '关闭' },
    confirmText: { type: String, default: '保存' },
    confirmLoading: { type: Boolean, default: false },
    withHeader: { type: Boolean, default: false },
    isTabDrawer: { type: Boolean, default: false },
    isDataSelect: {type: Boolean, default: true},
    saveText: { type: String, default: '保存' },
    saveLoading: { type: Boolean, default: false },
    showCancelButton: { type: Boolean, default: true },
    showSaveButton: { type: Boolean, default: false },
    showConfirmButton: { type: Boolean, default: true }
  },
  data() {
    return {
      isUserClosing: false
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.value
      },
      set(val) {
        // 如果用户没有主动关闭，但尝试设置为 false，则阻止
        if (!val && !this.isUserClosing) {
          return
        }
        this.$emit('input', val)
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        // 当父组件的 value 改变时，不需要特殊处理
        // computed 属性会自动处理
      },
      immediate: true
    }
  },
  methods: {
    handleClose() {
      // Element UI 的 close 事件，只有在用户主动关闭时才处理
      if (this.isUserClosing) {
        this.localVisible = false
        this.$emit('close')
      }
    },
    // 用户主动关闭的方法
    userClose() {
      this.isUserClosing = true
      this.localVisible = false
      this.$emit('close')
      this.$nextTick(() => {
        this.isUserClosing = false
      })
    }
  }
}
</script>

<style scoped>
.drawer-wrapper {
  background: rgba(244, 245, 246, 1);
}
.drawer-header {
  border-bottom: 1px solid rgba(228, 231, 237, 1);
}
.drawer-title {
  font-weight: 400;
  color: rgba(48, 49, 51, 1);
}
.drawer-close {
  color: rgba(48, 49, 51, 1);
}
.drawer-close:hover {
  color: rgba(48, 49, 51, 1);
}
.drawer-footer {
  box-shadow: 0px -1px 4px  rgba(0, 0, 0, 0.12);
  z-index: 99999;
}

/* 禁用遮罩层点击关闭 */
:deep(.el-drawer__wrapper) {
  pointer-events: none !important;
}

:deep(.el-drawer__wrapper .el-drawer__container) {
  pointer-events: auto !important;
}

:deep(.el-drawer__wrapper .el-drawer__container .el-drawer) {
  pointer-events: auto !important;
}

/* 确保遮罩层不可点击 */
:deep(.el-drawer__wrapper .el-drawer__container::before) {
  pointer-events: none !important;
}

/* 确保滚动条正确显示 */
.drawer-content {
  height: 100%; /* 减去header和footer的高度 */
  overflow-y: auto;
  overflow-x: hidden;
}
.drawer-content-box{
  min-height: 100%;
}
</style>


